import { Check, X } from "lucide-react";
import { useI18n } from "@/i18n";

// Shared "All categories" chooser sheet (centered modal on desktop,
// bottom sheet on mobile). Used by the Home feed and the Map page.
export default function CategorySheet({ open, tags, total, activeTag, onPick, onClose }) {
  const { t, tagLabel } = useI18n();
  if (!open) return null;
  return (
    <div className="dd-sheet-overlay" onClick={onClose} data-testid="category-sheet">
      <div className="dd-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="dd-sheet-handle" aria-hidden="true" />
        <div className="dd-sheet-head">
          <h2>{t("chooseCategory")}</h2>
          <button className="dd-sheet-close" onClick={onClose} aria-label="Close" data-testid="category-sheet-close">
            <X size={20} />
          </button>
        </div>
        <button className="dd-sheet-row" onClick={() => onPick(null)} data-testid="category-row-all">
          <span className="dd-sheet-label">{t("allCategories")}</span>
          <span className="dd-sheet-count">{total}</span>
          <span className={`dd-radio${activeTag === null ? " is-on" : ""}`}>
            {activeTag === null ? <Check size={13} strokeWidth={3} /> : null}
          </span>
        </button>
        {tags.map(({ tag, count }) => (
          <button className="dd-sheet-row" key={tag} onClick={() => onPick(tag)} data-testid={`category-row-${tag}`}>
            <span className="dd-sheet-label">{tagLabel(tag)}</span>
            <span className="dd-sheet-count">{count}</span>
            <span className={`dd-radio${activeTag === tag ? " is-on" : ""}`}>
              {activeTag === tag ? <Check size={13} strokeWidth={3} /> : null}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
